var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletLimsAtom2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 113,
    viewBox: "0 0 98 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.846 61.8144L45.6106 57.2961L51.0903 97.0956",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2274 65.5382C72.4665 61.0119 73.8977 55.1045 78.424 52.3437C82.9503 49.5828 88.8577 51.014 91.6185 55.5403C94.3794 60.0666 92.9482 65.974 88.4219 68.7348C83.8956 71.4956 77.9882 70.0645 75.2274 65.5382Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6276 61.8106C75.4834 58.8643 76.9193 55.934 79.6128 54.2912",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9533 101.756C37.6793 96.3885 39.3765 89.3832 44.744 86.1093C50.1114 82.8353 57.1167 84.5325 60.3906 89.9C63.6646 95.2675 61.9674 102.273 56.5999 105.547C51.2325 108.821 44.2272 107.123 40.9533 101.756Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.407 97.17C41.2417 93.7052 42.9194 90.2615 46.0947 88.3247",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0239 38.5056C7.94714 35.1009 9.02368 30.6574 12.4284 28.5807C15.8331 26.504 20.2766 27.5805 22.3533 30.9852C24.43 34.3899 23.3535 38.8334 19.9488 40.9101C16.5441 42.9869 12.1006 41.9103 10.0239 38.5056Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3511 35.9209C10.2431 33.6727 11.3296 31.4278 13.3948 30.1681L10.3511 35.9209Z",
    fill: "#80FFAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3511 35.9209C10.2431 33.6727 11.3296 31.4278 13.3948 30.1681",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1344 65.9899C31.0922 59.363 33.1876 50.714 39.8145 46.6719C46.4414 42.6297 55.0904 44.7251 59.1325 51.352C63.1746 57.9789 61.0793 66.6279 54.4524 70.67C47.8255 74.7121 39.1765 72.6168 35.1344 65.9899Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6747 60.1114C35.4709 55.8672 37.5353 51.6445 41.4162 49.2773",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletLimsAtom2);
export default __webpack_public_path__ + "static/media/tablet-lims-atom-2.b1d590f32395db18c64a6261eb252b1c.svg";
export { ForwardRef as ReactComponent };